export default __webpack_public_path__ + "static/media/tech-miyosmart-lenses-regular.648d7bd5.png";